import React from 'react'
import PropTypes from 'prop-types'
import { Editor } from '@tinymce/tinymce-react'

const TextEditor = ({ init, onChange, value, direction = 'ltr', ...props }) => {
  const [content, setContent] = React.useState('')

  const handleOnChange = (html) => {
    setContent(html)
    onChange(html)
  }

  const init_instance_callback = (editor) => {
    editor.on('OpenWindow', () => {
      const dialogTabs = document.querySelectorAll('.tox-dialog__body-nav-item.tox-tab')
      if (dialogTabs.length === 2) {
        dialogTabs[0].style.display = 'none'
        dialogTabs[1].click()
      }
      if (init.init_instance_callback) {
        init.init_instance_callback(editor)
      }
    })
  }

  React.useEffect(() => {
    if (!content.length) {
      setContent(value)
    }
  }, [value])

  return (
    <Editor
      {...props}
      apiKey="uptzutf04o1nyq6a4incdcdjzk9qsvg4b4eezamqesbd4sz6"
      onEditorChange={handleOnChange}
      value={content}
      init={{
        link_assume_external_targets: 'https',
        toolbar_mode: 'sliding',
        directionality: direction,
        image_description: false,
        image_dimensions: false,
        init_instance_callback,
        plugins: [
          'pagebreak hr advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount directionality',
        ],
        toolbar:
          'bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons fullscreen insertfile image pageembed template link codesample a11ycheck ltr rtl showcomments addcomment',
        language: localStorage.getItem('Locale'),
        font_formats:
          'Arial=arial,helvetica,sans-serif; Amiri=Amiri; Cairo=Cairo; Crimson Text=CrimsonText; Lato=Lato; Montserrat=Montserrat; Open Sans=OpenSans; Oxygen=Oxygen; Roboto=Roboto; Tanseek Modern Pro Arabic=TanseekModernProArabic; HS=HungerStation;',
        content_style:
          "@import url('https://tinyfont.s3.me-south-1.amazonaws.com/tiny_font_new.css');",
        ...init,
      }}
    />
  )
}

TextEditor.propTypes = {
  init: PropTypes.shape(),
  onChange: PropTypes.func,
  value: PropTypes.string,
}

TextEditor.defaultProps = {
  onChange: () => {},
}

export default TextEditor
